// @ts-nocheck
import * as Types from "../../../../../../../types/types";

import { gql } from "@apollo/client";
import {
  IncidentIoDeliveryFieldsFragmentDoc,
  WebhookDeliveryFieldsFragmentDoc,
} from "./Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WebhookDeliveriesQueryVariables = Types.Exact<{
  webhookEndpointId: Types.Scalars["ID"]["input"];
  statuses?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type WebhookDeliveriesQuery = {
  __typename?: "GraphqlQuery";
  getWebhookDeliveries: Array<{
    __typename?: "WebhookDelivery";
    id: string;
    eventId: string;
    eventType: string;
    status: string;
    attempts: number;
    nextAttemptAt?: number | null;
    lastAttemptAt?: number | null;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorKind?: string | null;
    errorMessage?: string | null;
    payload: any;
    createdAt: number;
    issue?: {
      __typename?: "Issue";
      id: string;
      description: string;
      checkGroupAndName: string;
      server: {
        __typename?: "Server";
        id: string;
        humanId: string;
        name: string;
      };
      database?: { __typename?: "Database"; id: string } | null;
    } | null;
  }>;
};

export type IncidentIoDeliveriesQueryVariables = Types.Exact<{
  incidentIoEndpointId: Types.Scalars["ID"]["input"];
  statuses?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type IncidentIoDeliveriesQuery = {
  __typename?: "GraphqlQuery";
  getIncidentIoDeliveries: Array<{
    __typename?: "IncidentIoDelivery";
    id: string;
    deduplicationKey: string;
    eventType: string;
    status: string;
    attempts: number;
    nextAttemptAt?: number | null;
    lastAttemptAt?: number | null;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorKind?: string | null;
    errorMessage?: string | null;
    payload: any;
    createdAt: number;
    issue?: {
      __typename?: "Issue";
      id: string;
      description: string;
      checkGroupAndName: string;
      server: {
        __typename?: "Server";
        id: string;
        humanId: string;
        name: string;
      };
      database?: { __typename?: "Database"; id: string } | null;
    } | null;
  }>;
};

export const WebhookDeliveriesDocument = gql`
  query WebhookDeliveries(
    $webhookEndpointId: ID!
    $statuses: [String!]
    $limit: Int
    $offset: Int
  ) {
    getWebhookDeliveries(
      webhookEndpointId: $webhookEndpointId
      statuses: $statuses
      limit: $limit
      offset: $offset
    ) {
      ...WebhookDeliveryFields
    }
  }
  ${WebhookDeliveryFieldsFragmentDoc}
`;

/**
 * __useWebhookDeliveriesQuery__
 *
 * To run a query within a React component, call `useWebhookDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookDeliveriesQuery({
 *   variables: {
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useWebhookDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  > &
    (
      | { variables: WebhookDeliveriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  >(WebhookDeliveriesDocument, options);
}
export function useWebhookDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  >(WebhookDeliveriesDocument, options);
}
// @ts-ignore
export function useWebhookDeliveriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WebhookDeliveriesQuery,
  WebhookDeliveriesQueryVariables
>;
export function useWebhookDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebhookDeliveriesQuery,
        WebhookDeliveriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WebhookDeliveriesQuery | undefined,
  WebhookDeliveriesQueryVariables
>;
export function useWebhookDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebhookDeliveriesQuery,
        WebhookDeliveriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WebhookDeliveriesQuery,
    WebhookDeliveriesQueryVariables
  >(WebhookDeliveriesDocument, options);
}
export type WebhookDeliveriesQueryHookResult = ReturnType<
  typeof useWebhookDeliveriesQuery
>;
export type WebhookDeliveriesLazyQueryHookResult = ReturnType<
  typeof useWebhookDeliveriesLazyQuery
>;
export type WebhookDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useWebhookDeliveriesSuspenseQuery
>;
export type WebhookDeliveriesQueryResult = Apollo.QueryResult<
  WebhookDeliveriesQuery,
  WebhookDeliveriesQueryVariables
>;
export const IncidentIoDeliveriesDocument = gql`
  query IncidentIoDeliveries(
    $incidentIoEndpointId: ID!
    $statuses: [String!]
    $limit: Int
    $offset: Int
  ) {
    getIncidentIoDeliveries(
      incidentIoEndpointId: $incidentIoEndpointId
      statuses: $statuses
      limit: $limit
      offset: $offset
    ) {
      ...IncidentIoDeliveryFields
    }
  }
  ${IncidentIoDeliveryFieldsFragmentDoc}
`;

/**
 * __useIncidentIoDeliveriesQuery__
 *
 * To run a query within a React component, call `useIncidentIoDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentIoDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentIoDeliveriesQuery({
 *   variables: {
 *      incidentIoEndpointId: // value for 'incidentIoEndpointId'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useIncidentIoDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  > &
    (
      | { variables: IncidentIoDeliveriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  >(IncidentIoDeliveriesDocument, options);
}
export function useIncidentIoDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  >(IncidentIoDeliveriesDocument, options);
}
// @ts-ignore
export function useIncidentIoDeliveriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IncidentIoDeliveriesQuery,
  IncidentIoDeliveriesQueryVariables
>;
export function useIncidentIoDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IncidentIoDeliveriesQuery,
        IncidentIoDeliveriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IncidentIoDeliveriesQuery | undefined,
  IncidentIoDeliveriesQueryVariables
>;
export function useIncidentIoDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IncidentIoDeliveriesQuery,
        IncidentIoDeliveriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IncidentIoDeliveriesQuery,
    IncidentIoDeliveriesQueryVariables
  >(IncidentIoDeliveriesDocument, options);
}
export type IncidentIoDeliveriesQueryHookResult = ReturnType<
  typeof useIncidentIoDeliveriesQuery
>;
export type IncidentIoDeliveriesLazyQueryHookResult = ReturnType<
  typeof useIncidentIoDeliveriesLazyQuery
>;
export type IncidentIoDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useIncidentIoDeliveriesSuspenseQuery
>;
export type IncidentIoDeliveriesQueryResult = Apollo.QueryResult<
  IncidentIoDeliveriesQuery,
  IncidentIoDeliveriesQueryVariables
>;
